import type { CommunityDetail } from '@pba/react-network';
import { Col, Icon, Image, Row, Tag, Title } from 'ui';

type P = {
  community: CommunityDetail;
};

// TODO: replace with a shared image size once Image widths are defined in one place
const coverPhotoWidth = 128;

const CommunityInfo = ({ community }: P) => (
  <Row gutter={['xs', 0]}>
    <Col>
      <Image borderRadius="small" preview={false} src={community.coverPhoto?.url} width={coverPhotoWidth} />
    </Col>
    <Col flex="1">
      <Row>
        <Col span={24}>
          <Tag color="green" icon={<Icon icon="classify-2-line" />}>
            Community
          </Tag>
          <Title level={3} marginBottom>
            {community.name}
          </Title>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default CommunityInfo;
